module.exports = __webpack_public_path__ + "static/Boy.318ec57d.png";